import { useState } from "react";
import "./css/DonationCard.css";

const CopyIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  </svg>
);

const CheckIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

function CopyButton({ text }) {
  const [copied, setCopied] = useState(false);

  const handle = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    });
  };

  return (
    <button onClick={handle} className={`copy-btn ${copied ? "copied" : ""}`}>
      {copied ? <CheckIcon /> : <CopyIcon />}
      {copied ? "Copied!" : "Copy"}
    </button>
  );
}

const bankRows = [
  { label: "Beneficiary Name", value: "Veer Samyak Foundation",          copy: false, mono: false },
  { label: "Account Number",   value: "2525002100015313",                 copy: true,  mono: true  },
  { label: "Bank Name",        value: "Punjab National Bank, Mahasamund", copy: false, mono: false },
  { label: "IFSC Code",        value: "PUNB0252500",                      copy: true,  mono: true  },
];

export default function DonationCard() {
  return (
   <div className="customcontainer">
     <div className="donation-wrapper">
      <div className="donation-card">


        <div className="donation-header">
          <div>
            <div className="donation-header-pre">Support the Journey.</div>
            <div className="donation-header-title">Veer Samyak Sankalp Foundation</div>
          </div>
        </div>

        <div className="donation-body">

          {/* LEFT — Bank Details */}
          <div className="donation-left">
            <div className="donation-section-title">Bank Details</div>

            {bankRows.map((row, i) => (
              <div key={i} className="donation-row">
                <div className="donation-row-label">{row.label}</div>
                <div className="donation-row-value">
                  <span className={`donation-val-text ${row.mono ? "mono" : ""}`}>
                    {row.value}
                  </span>
                  {row.copy && <CopyButton text={row.value} />}
                </div>
              </div>
            ))}
          </div>

       

          {/* RIGHT — Quote + QR */}
          <div className="donation-right">

            <div className="donation-quote-box">
              <div className="donation-quote-mark">"</div>
              <p className="donation-quote-text">
              Your contribution is the silent force behind every life we transform. Whether it is a single meal, a life-saving surgery, or a child’s first book your generosity is directed with absolute precision toward the most noble causes.
              </p>
              <div className="donation-quote-mark bottom">"</div>
            </div>

            

          </div>
        </div>

      </div>
    </div>
   </div>
  );
}